import { render, staticRenderFns } from "./ProgramTypesStimulationsTable.vue?vue&type=template&id=130da442&"
import script from "./ProgramTypesStimulationsTable.vue?vue&type=script&lang=js&"
export * from "./ProgramTypesStimulationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports